import { render, staticRenderFns } from "./new-password.vue?vue&type=template&id=41b35157&"
import script from "./new-password.vue?vue&type=script&lang=js&"
export * from "./new-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewPassword: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/NewPassword/index.vue').default})
